import { createSlice } from "@reduxjs/toolkit";

const MemberPanelAuthSlice = createSlice({
  name: "memberPanelAuthSlice",
  initialState: {
    is_auth: 0,
  },
  reducers: {
    refreshMemberPanelAuthReducer: (state, action) => {
      state.is_auth += 1;
    },
  },
});

export default MemberPanelAuthSlice;
